'use client';

import { GetAccountActionReturn } from '../sdk/composable-commerce/types/actions/AccountActions';
import { SDKResponse } from '@commercetools/frontend-sdk';
import Toaster from 'components/commercetools-ui/atoms/toaster';
import AddToCartOverlayProvider from 'context/add-to-cart-overlay';
import { sdk } from 'sdk';
import { Translations } from 'types/i18n';
import I18nProvider from './i18n';
import { SWRProvider } from './swr';
import { CookiesProvider, useCookies } from 'react-cookie';
import useLocale from 'helpers/hooks/useLocale';

interface ProvidersProps {
  translations: Translations;
  accountResult?: SDKResponse<GetAccountActionReturn>;
}

export const Providers = ({ translations, accountResult, children }: React.PropsWithChildren<ProvidersProps>) => {
  const { ctLocale: locale } = useLocale();
  const [cookies, _] = useCookies(['locale_selection']);
  const currencyCookie = cookies?.locale_selection ? cookies?.locale_selection['currency'] : 'GBP';

  sdk.configureForNext(locale, currencyCookie);

  return (
    <I18nProvider translations={translations}>
      <SWRProvider value={{ fallback: { '/action/account/getAccount': accountResult } }}>
        <CookiesProvider defaultSetOptions={{ path: '/' }}>
          <AddToCartOverlayProvider>{children}</AddToCartOverlayProvider>
          <Toaster />
        </CookiesProvider>
      </SWRProvider>
    </I18nProvider>
  );
};
